module.exports = __webpack_public_path__ + "img/facebook.1466d373.svg";